module.exports = __webpack_public_path__ + "img/back.4757873f.a921d261.jpg";